import { Transition, MantineTransition } from '@mantine/core';
// @ts-ignore - react-transition-group types not installed
import { TransitionGroup } from 'react-transition-group';
import { Box } from '@mantine/core';
import { forwardRef, Children, cloneElement, isValidElement } from 'react';
import { useReducedMotion } from '../hooks';

export interface AnimatedGroupProps {
  children: React.ReactNode;
  transition?: MantineTransition;
  duration?: number;
  staggerDelay?: number;
}

/**
 * Animates a group of children with staggered delays
 */
const AnimatedGroup = forwardRef<HTMLDivElement, AnimatedGroupProps>(
  (
    {
      children,
      transition = 'fade',
      duration = 200,
      staggerDelay = 50,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const actualDuration = reducedMotion ? 0 : duration;

    const childArray = Children.toArray(children);

    return (
      <Box ref={ref}>
        {childArray.map((child, index) => {
          const delay = reducedMotion ? 0 : index * staggerDelay;

          return (
            <Transition
              key={index}
              mounted={true}
              transition={transition}
              duration={actualDuration}
              timingFunction="ease-out"
            >
              {(styles) => (
                <Box
                  style={{
                    ...styles,
                    transitionDelay: `${delay}ms`,
                    animationDelay: `${delay}ms`,
                  }}
                >
                  {child}
                </Box>
              )}
            </Transition>
          );
        })}
      </Box>
    );
  }
);

AnimatedGroup.displayName = 'AnimatedGroup';

export default AnimatedGroup;
